var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnvs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.0295,
    y: 48.1461,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(-150 64.0295 48.1461)",
    fill: "#161616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60.9538,
    y: 38.9999,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#161616"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0295,
    y: 32.7321,
    width: 6,
    height: 2,
    rx: 1,
    transform: "rotate(150 65.0295 32.7321)",
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0134 16.78C54.0134 29.52 27.7234 29.1 27.7234 39.99C27.7234 44.61 31.7334 47.12 36.0334 49.52",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6534 16.78C27.6534 21.95 31.9034 24.95 36.9634 27.42",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6534 63.22C27.6534 52.8102 45.206 51.1866 51.6267 45M45.6334 30.48C47.9919 31.7964 50.2632 33.1459 51.8334 34.8585",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0134 34.8585C56.3059 36.2683 57.1234 37.9241 57.1234 40.01C57.1234 42.0018 56.2439 43.6152 54.8067 45",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0134 63.22C54.0134 58.05 49.7634 55.05 44.7034 52.58",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 19.7H28.3334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8334 40H28.3334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3334 40H44.8334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8334 35H30.8334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8334 45H29.8334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 60.82H28.8334",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnvs);
export default __webpack_public_path__ + "static/media/snvs.b8535b7d64f7bd95c8e641309b2adf58.svg";
export { ForwardRef as ReactComponent };